// Dates in the workshop's language, not the browser's.
const DATE_LOCALE = { fi: 'fi-FI', en: 'en-GB', sv: 'sv-FI' };

export function formatDateTime(value, language) {
  return new Date(value).toLocaleString(DATE_LOCALE[language] || 'fi-FI');
}
